import { AutoFixHigh } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { keyframes } from '@mui/system';
import React from 'react';

// Rainbow color animation - just the icon colors
const rainbowColors = keyframes`
  0% { color: #ff6b6b; }
  16% { color: #ffa726; }
  33% { color: #ffeb3b; }
  50% { color: #66bb6a; }
  66% { color: #42a5f5; }
  83% { color: #ab47bc; }
  100% { color: #ff6b6b; }
`;

interface MagicWandButtonProps {
  onClick: () => void;
  visible: boolean;
  disabled?: boolean;
}

export const MagicWandButton: React.FC<MagicWandButtonProps> = ({ onClick, visible, disabled = false }) => {
  return (
    <IconButton
      size="small"
      onClick={onClick}
      disabled={disabled}
      sx={{
        visibility: visible ? 'visible' : 'hidden',
        '&:hover': {
          bgcolor: 'divider',
        },
        // Rainbow animation on the icon
        '& .MuiSvgIcon-root': {
          animation: `${rainbowColors} 3s ease-in-out infinite`,
        },
      }}
    >
      <AutoFixHigh />
    </IconButton>
  );
};

export default MagicWandButton;

// export const MagicWandButton: React.FC<{
//   onClick: () => void;
//   visible: boolean;
// }> = ({ onClick, visible }) => {
//   return (
//     <IconButton
//       size="small"
//       onClick={onClick}
//       sx={{
//         visibility: visible ? 'visible' : 'hidden',
//         color: 'primary.light',
//         '&:hover': { bgcolor: 'divider' },
//         mb: 0.5,
//       }}
//     >
//       <AutoFixHigh color="inherit" />
//     </IconButton>
//   );
// };
